"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDialogMode = void 0;
var _react = require("react");
var _dialogModeContext = require("../../context/dialogModeContext");
const useDialogMode = () => {
  const context = (0, _react.useContext)(_dialogModeContext.dialogModeContext);
  if (context) {
    return context;
  }
  throw new Error('Value for `modeContext` must be set.');
};
exports.useDialogMode = useDialogMode;
